import React from 'react';
import { ResultModal } from '../../../common/components/redesignComponents/ResultPageComponents/v2/ResultModal.styles';
import EuropeassistanceCard from '../../../common/components/redesignComponents/Cards/EuropeassistanceCard';
import { capitalizeTitle } from '../../../common/components/redesignComponents/ResultPageComponents/ResultPageModal';

function TravelModal({
  type,
  addingQuote,
  quotes,
  requestToken,
  insuranceRequest,
  selectQuotation,
  fetchQuotes,
}) {
  return (
    <ResultModal
      className="modal fade"
      id={type.id}
      tabIndex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLabel">
              <h5>{type.id == 'res_civile' ? 'Viaggi' : capitalizeTitle(type.name)}</h5>
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              id="buttonClose"
            />
          </div>
          <div className="modal-body">
            {addingQuote && (
              <div className="d-flex align-items-center justify-content-between flex-column">
                <div className="d-flex justify-content-center">
                  <div className="spinner-border" role="status">
                    <span className="visually-hidden">
                      Aggiungendo...
                    </span>
                  </div>
                </div>
                <div className="ms-2">Aggiungendo...</div>
              </div>
            )}
            {addingQuote === false && (
              <div className="row purchase-quote-eight-step p-1">
                {addingQuote === false && quotes && quotes[type.id] ? (
                  quotes[type.id].map((quote, index) => (
                    <>
                      {type.id === 'res_civile' && (
                        <EuropeassistanceCard
                          quote={quote}
                          requestToken={requestToken}
                          guarantees={quote.quotation_coverages}
                          insuranceRequest={insuranceRequest}
                          key={index}
                          selectQuotation={selectQuotation}
                          fetchData={fetchQuotes}
                        />
                      )}
                    </>
                  ))
                ) : (
                  <h5 className="fw-bold">
                    Nessuna Quotazione Trovata
                  </h5>
                )}
              </div>
            )}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-danger px-4"
              data-bs-dismiss="modal"
            >
              Chiudi
            </button>
          </div>
        </div>
      </div>
    </ResultModal>
  );
}

export default TravelModal;
